// Centralized content for ConnectHer site

export const BRAND = {
  name: "ConnectHER",
  tagline: "The Divine Connector",
  motto: "Build · Connect · Empower",
  email: "info@thechhq.com",
  emails: {
    public: "info@thechhq.com",
    appointment: "appointment@thechhq.com",
    intake: "intake@thechhq.com",
    credit: "credit@thechhq.com",
    tax: "tax@thechhq.com",
    billing: "billing@thechhq.com",
    admin: "admin@thechhq.com",
  },
  phone: "(317) 766-1549",
  location: "Indianapolis, IN · Serving clients nationwide",
  acuityUrl: "https://app.acuityscheduling.com/schedule.php?owner=38449683",
  jotformUrl: "https://form.jotform.com/260505383429054",
  cdmSignupUrl: "https://www.newclientsignup.com/Agreement/Onboarding?crepto=OYyVnLAJvA%2bEnEzm2ZmVKw%3d%3d",
  bookipiUrl: "https://web.bookipi.com/dashboard",
  foraAdvisorUrl: "https://www.foratravel.com/advisor/devyne-harris",
  foraReferralUrl: "https://www.foratravel.com/apply",
  social: {
    instagram: "https://www.instagram.com/connectherhq",
    facebook: "https://www.facebook.com/share/1D3tVGvqez/?mibextid=wwXIfr",
    facebookDivinityTaxes: "https://www.facebook.com/divinity.taxes/",
    linkedin: "",
  },
  logoLight: "https://customer-assets.emergentagent.com/job_upgrade-web-4/artifacts/qbbdrrns_FFDD0762-32FF-400B-8794-0C2705294CCC.png",
  logoDark: "https://customer-assets.emergentagent.com/job_upgrade-web-4/artifacts/9kc97uyn_74EB1DD1-D50B-4BCC-9CDA-E60D9ED96FC8.png",
};

export const SERVICES = [
  {
    slug: "bookkeeping",
    name: "Bookkeeping",
    short: "Clean books. Confident decisions.",
    tagline: "Cleanup, monthly bookkeeping, Bill.com setup — for entrepreneurs, nonprofits & small businesses.",
    icon: "BookOpen",
    color: "navy",
    price_label: "From $350/mo",
    price_cents: 35000,
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=1400&q=80",
    description:
      "We turn the shoebox of receipts into a clear, audit-ready financial picture. Our team handles QuickBooks setup, cleanup, reconciliation, and reporting — plus Bill.com management for the operations that touch payables.",
    bullets: [
      "Startup cleanup: $1,000 (0–1 yr) · $1,500 (1–3 yr) · $2,000+ (3+ yr)",
      "Monthly retainers based on transaction volume",
      "QuickBooks Online setup & maintenance",
      "Bill.com setup ($250) + ongoing management ($100/mo)",
      "Monthly P&L, Balance Sheet, and tax-ready packages",
      "Custom-quoted catch-up & cleanup projects",
    ],
    tiers: [
      // Cleanup
      { id: "bk-cleanup-new", name: "Startup Cleanup (0–1 year)", price_cents: 100000, label: "From $1,000" },
      { id: "bk-cleanup-est", name: "Established Cleanup (1–3 years)", price_cents: 150000, label: "From $1,500" },
      { id: "bk-cleanup-mature", name: "Established Cleanup (3+ years)", price_cents: 200000, label: "From $2,000+" },
      // Monthly retainers
      { id: "bk-tier1", name: "Monthly · 0–100 transactions", price_cents: 35000, label: "$350 / month" },
      { id: "bk-tier2", name: "Monthly · 101–250 transactions", price_cents: 50000, label: "$500 / month" },
      { id: "bk-tier3", name: "Monthly · 251–500 transactions", price_cents: 75000, label: "$750 / month" },
      { id: "bk-tier4", name: "Monthly · 500+ transactions", price_cents: 0, label: "Custom quote" },
      // Add-ons
      { id: "bk-bill-setup", name: "Bill.com Setup", price_cents: 25000, label: "$250" },
      { id: "bk-bill-mo", name: "Bill.com Ongoing Management", price_cents: 10000, label: "$100 / month" },
      // Signature onboarding
      { id: "bk-signature", name: "Signature Onboarding (90-day → $350/mo)", price_cents: 100000, label: "$1,000 m1 · $500 m2–3 · $350 m4+" },
    ],
  },
  {
    slug: "business-formation",
    name: "Business Formation",
    short: "Launch the right way — from day one.",
    tagline: "LLC, EIN, operating agreement, and premium startup packages.",
    icon: "Building2",
    color: "gold",
    price_label: "From $399",
    price_cents: 39900,
    image: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=1400&q=80",
    description:
      "Choosing the right entity affects your taxes, liability, and ability to receive grants and funding for years. We guide you through the decision and handle the filing.",
    bullets: [
      "LLC formation, state registration, registered agent",
      "EIN filing with the IRS",
      "Operating Agreement drafted to your needs",
      "Premium package includes compliance review",
      "Business banking & credit setup guidance",
    ],
    tiers: [
      { id: "bf-llc", name: "LLC Formation", price_cents: 39900, label: "$399" },
      { id: "bf-llc-ein-oa", name: "LLC + EIN + Operating Agreement", price_cents: 69900, label: "$699" },
      { id: "bf-premium", name: "Premium Business Startup Package", price_cents: 99900, label: "$999 (best value)" },
      { id: "bf-oa-only", name: "Operating Agreement Only", price_cents: 25000, label: "$250" },
      { id: "bf-ein", name: "EIN Filing", price_cents: 10000, label: "$100" },
      { id: "bf-ra", name: "Registered Agent Assistance", price_cents: 15000, label: "$150" },
      { id: "bf-compliance", name: "Business Compliance Review", price_cents: 25000, label: "$250" },
    ],
  },
  {
    slug: "consulting",
    name: "Business Consulting",
    short: "The strategy & structure behind your growth.",
    tagline: "Strategy sessions and monthly retainers across three tiers.",
    icon: "Briefcase",
    color: "teal",
    price_label: "From $150",
    price_cents: 15000,
    image: "https://images.unsplash.com/photo-1573164574572-cb89e39749b4?w=1400&q=80",
    description:
      "From systems and SOPs to growth strategy and operations, we plug in and create the structure that lets you scale without burning out.",
    bullets: [
      "1-on-1 strategy sessions (60 or 90 min)",
      "Three monthly retainer tiers: Starter · Growth · Executive",
      "Process documentation and SOP creation",
      "Vendor, contractor, and client coordination",
      "Project management setup (ClickUp, Asana, Notion)",
    ],
    tiers: [
      { id: "co-60", name: "60-Minute Consultation", price_cents: 15000, label: "$150" },
      { id: "co-90", name: "90-Minute Consultation", price_cents: 22500, label: "$225" },
      { id: "co-starter", name: "Starter Retainer", price_cents: 50000, label: "$500 / month" },
      { id: "co-growth", name: "Growth Retainer", price_cents: 100000, label: "$1,000 / month" },
      { id: "co-executive", name: "Executive Retainer", price_cents: 200000, label: "$2,000+ / month" },
    ],
  },
  {
    slug: "taxes",
    name: "Divinity Taxes",
    short: "Tax preparation with intention.",
    tagline: "Individual, self-employed, and business tax preparation powered by Drake Tax.",
    icon: "Calculator",
    color: "navy",
    price_label: "$0 upfront · paid from refund",
    price_cents: 0,
    image: "https://images.unsplash.com/photo-1554224154-26032cdc0eea?w=1400&q=80",
    description:
      "Powered by Drake Tax Software, Divinity Taxes blends careful preparation with proactive planning so you keep more of what you earn — legally and confidently. No upfront cost: prep fees are deducted directly from your federal refund through EPS Financial (our tax-banking partner). Pricing is based on the complexity of your return and is discussed during your consultation. If you owe taxes (no refund expected), payment is due at filing.",
    bullets: [
      "No upfront cost — fees deducted from your federal refund through EPS Financial",
      "W-2 / 1040 returns",
      "Schedule C self-employed returns (SmartClerk-powered expense extraction)",
      "Complex returns (rentals, K-1s, multi-state)",
      "Prior-year and amended returns",
      "IRS notice review and response",
    ],
    tiers: [
      { id: "tx-w2", name: "Individual Return (W-2 / 1040)", price_cents: 0, label: "Quoted at consultation" },
      { id: "tx-schc", name: "Schedule C / Self-Employed", price_cents: 0, label: "Quoted at consultation" },
      { id: "tx-biz", name: "Business Return (LLC / S-Corp)", price_cents: 0, label: "Quoted at consultation" },
      { id: "tx-prior", name: "Prior-Year or Amended Return", price_cents: 0, label: "Quoted at consultation" },
      { id: "tx-letter", name: "IRS Letter Review", price_cents: 0, label: "Quoted at consultation" },
    ],
  },
  {
    slug: "travel",
    name: "Travel Services",
    short: "Complimentary planning through preferred partners.",
    tagline: "Curated by Devyne. Booked through Fora's luxury network — most planning at no cost to you.",
    icon: "Plane",
    color: "teal",
    price_label: "Free booking · planning fees only for groups & custom itineraries",
    price_cents: 0,
    image: "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=1400&q=80",
    description:
      "ConnectHER Travel – Curated by Devyne — is built for women, families, and businesses who want a thoughtful travel experience without the planning stress. Because we book through Fora's luxury partner network, hotel and cruise bookings are always free. We only charge a planning fee for group travel, custom multi-destination itineraries, and destination weddings — where the research is significant.",
    bullets: [
      "Hotel bookings — no fee",
      "Cruise bookings — no fee",
      "Group Travel Planning (3–10 travelers) — $150 flat fee",
      "Large Group Travel (11+ travelers) — $250 to $500",
      "Custom Multi-Destination Itinerary — starting at $250",
      "Destination Wedding Research & Coordination — starting at $500",
    ],
    tiers: [
      { id: "tv-hotel", name: "Hotel Booking", price_cents: 0, label: "No Fee" },
      { id: "tv-cruise", name: "Cruise Booking", price_cents: 0, label: "No Fee" },
      { id: "tv-group", name: "Group Travel Planning (3–10)", price_cents: 15000, label: "$150" },
      { id: "tv-large", name: "Large Group Travel (11+)", price_cents: 25000, label: "$250–$500" },
      { id: "tv-multi", name: "Custom Multi-Destination Itinerary", price_cents: 25000, label: "From $250" },
      { id: "tv-wedding", name: "Destination Wedding Research & Coordination", price_cents: 50000, label: "From $500" },
    ],
  },
  {
    slug: "notary",
    name: "Notary Services",
    short: "Trusted, mobile, and remote notarization.",
    tagline: "General, mobile, and loan signing services — based on Indiana state guidelines.",
    icon: "FileSignature",
    color: "navy",
    price_label: "State fee + travel",
    price_cents: 0,
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=1400&q=80",
    description:
      "Our commissioned notary delivers speed, professionalism, and confidentiality — whether you need a single document notarized in-office or a full loan signing handled at your kitchen table.",
    bullets: [
      "General notary at Indiana state guideline fees",
      "Mobile notary with affordable travel rates",
      "Loan signing services (purchase, refinance, seller)",
      "Remote Online Notarization (RON)",
      "Power of attorney, affidavits, healthcare directives",
    ],
    tiers: [
      { id: "no-mobile", name: "Mobile Notary Travel Fee", price_cents: 3500, label: "From $35" },
      { id: "no-purchase", name: "Loan Signing · Purchase Package", price_cents: 12500, label: "$125 – $175" },
      { id: "no-refi", name: "Loan Signing · Refinance Package", price_cents: 10000, label: "$100 – $150" },
      { id: "no-seller", name: "Loan Signing · Seller Package", price_cents: 10000, label: "$100 – $125" },
    ],
  },
  {
    slug: "credit-repair",
    name: "Anew Credit Repair",
    short: "A new credit story starts here.",
    tagline: "Strategic credit repair, dispute, and rebuilding programs — 3 tiers, 6-month commitment.",
    icon: "ShieldCheck",
    color: "gold",
    price_label: "From $99.97/mo",
    price_cents: 9997,
    image: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=1400&q=80",
    description:
      "Powered by industry-leading tools (Client Dispute Manager, SmartCredit, FreedomPath), Anew Credit Repair combines accuracy disputes, education, and rebuilding strategy to move your score with intention. All programs require a 6-month commitment.",
    bullets: [
      "Initial Credit Analysis — $199",
      "Essentials Program — $99.97/mo",
      "Signature Program — $109.97/mo",
      "Platinum Program — $139.97/mo",
      "Tri-bureau audit and dispute strategy",
      "Score monitoring with SmartCredit",
      "Personalized rebuilding roadmap",
      "Monthly progress reviews (6-month minimum)",
    ],
    tiers: [
      { id: "cr-analysis", name: "Initial Credit Analysis", price_cents: 19900, label: "$199" },
      { id: "cr-essentials", name: "Essentials Program", price_cents: 9997, label: "$99.97 / month" },
      { id: "cr-signature", name: "Signature Program", price_cents: 10997, label: "$109.97 / month" },
      { id: "cr-platinum", name: "Platinum Program", price_cents: 13997, label: "$139.97 / month" },
    ],
  },
  {
    slug: "business-credit",
    name: "Business Credit Services",
    short: "Build business credit. Unlock funding.",
    tagline: "FreedomPath-powered business credit setup, building, and funding preparation.",
    icon: "TrendingUp",
    color: "teal",
    price_label: "From $149/mo",
    price_cents: 14900,
    image: "https://images.unsplash.com/photo-1518186285589-2f7649de83e0?w=1400&q=80",
    description:
      "Personal credit gets you in the door — business credit gets you funded. Through FreedomPath, we set up your business credit profile, build it strategically with tier-1 vendors, and prepare you for funding when you're ready.",
    bullets: [
      "FreedomPath Business Credit Starter setup ($499)",
      "Monthly Business Credit Builder program ($149/mo)",
      "Premium Funding Preparation ($299/mo)",
      "DUNS number, Experian Business, Equifax SBFE setup",
      "Tier 1–4 vendor placement strategy",
      "Tradeline reporting and monitoring",
    ],
    tiers: [
      { id: "bc-setup", name: "FreedomPath Starter Setup", price_cents: 49900, label: "$499 (one-time)" },
      { id: "bc-builder", name: "Business Credit Builder", price_cents: 14900, label: "$149 / month" },
      { id: "bc-funding", name: "Premium Funding Preparation", price_cents: 29900, label: "$299 / month" },
    ],
  },
  {
    slug: "money-mindset",
    name: "Money Mindset Reset™",
    short: "Heal your money story. Build wealth on purpose.",
    tagline: "1:1 coaching and group programs that rewire how you think, feel, and act around money.",
    icon: "Sparkles",
    color: "gold",
    price_label: "From $75 / session",
    price_cents: 7500,
    image: "https://images.unsplash.com/photo-1593013820600-3d24c2a0e6e2?w=1400&q=80",
    description:
      "Money Mindset Reset™ is the inner work that makes the outer work stick. Pair it with bookkeeping, credit repair, or business consulting to create lasting financial transformation — not just temporary fixes.",
    bullets: [
      "Individual coaching sessions ($75/session)",
      "Structured 4-week program ($297) — habits, beliefs, action",
      "Deep 8-week program ($497) — full reset + accountability",
      "Group workshops for organizations & community ($25+/person)",
      "Journals, exercises, and follow-along curriculum",
    ],
    tiers: [
      { id: "mm-session", name: "Individual Session", price_cents: 7500, label: "$75 / session" },
      { id: "mm-4wk", name: "4-Week Program", price_cents: 29700, label: "$297" },
      { id: "mm-8wk", name: "8-Week Program", price_cents: 49700, label: "$497" },
      { id: "mm-group", name: "Group Workshop", price_cents: 2500, label: "From $25 / person" },
    ],
  },
  {
    slug: "admin-services",
    name: "Administrative Services",
    short: "The right-hand support you've needed.",
    tagline: "Hourly virtual assistance, monthly retainers, document prep, and CRM setup.",
    icon: "ClipboardList",
    color: "navy",
    price_label: "From $45 / hr",
    price_cents: 4500,
    image: "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?w=1400&q=80",
    description:
      "ConnectHer Administrative Services give entrepreneurs and small teams polished, dependable back-office support — without hiring a full-time employee.",
    bullets: [
      "Hourly virtual administrative support ($45/hr)",
      "Monthly retainer engagements (from $500/mo)",
      "Document preparation (from $75)",
      "CRM & systems setup (from $250)",
      "Inbox, calendar, and project management",
      "Templates, intake forms, and onboarding flows",
    ],
    tiers: [
      { id: "as-hourly", name: "Virtual Admin Support", price_cents: 4500, label: "$45 / hour" },
      { id: "as-retainer", name: "Monthly Retainer", price_cents: 50000, label: "From $500 / month" },
      { id: "as-docs", name: "Document Preparation", price_cents: 7500, label: "From $75" },
      { id: "as-crm", name: "CRM & Systems Setup", price_cents: 25000, label: "From $250" },
    ],
  },
  {
    slug: "real-estate",
    name: "Real Estate Services",
    short: "Journey to Keys™ — coming soon.",
    tagline: "From rent-ready to home-ready. A guided path to ownership.",
    icon: "KeyRound",
    color: "gold",
    price_label: "Coming Soon",
    price_cents: 0,
    comingSoon: true,
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1400&q=80",
    description:
      "Our flagship Journey to Keys™ program will combine credit, savings, and homebuyer education into a structured path toward closing your first (or next) home. Join the early-access list and be the first to know when enrollment opens.",
    bullets: [
      "Pre-qualification and lender introductions",
      "Down-payment and closing-cost roadmap",
      "Credit and DTI optimization (via Anew Credit Repair)",
      "Homebuyer education curriculum",
      "Real estate agent matchmaking",
    ],
    tiers: [],
  },
];

export const SERVICES_BY_SLUG = Object.fromEntries(SERVICES.map((s) => [s.slug, s]));

export const FAQS = [
  { q: "What is ConnectHer?", a: "ConnectHer is an ecosystem of services designed to help individuals, entrepreneurs, nonprofits, and small businesses build stronger financial systems, access resources, and create lasting opportunities." },
  { q: "How do I get started?", a: "Book a free 15-minute discovery call through our Book Appointment page. We'll learn about your goals and recommend the right service or bundle for you." },
  { q: "Do you work with clients outside of Indiana?", a: "Yes. We're based in Indianapolis but serve clients across the United States. Bookkeeping, taxes, credit repair, and business formation are all delivered remotely." },
  { q: "Can I bundle multiple services?", a: "Absolutely. Many of our clients combine bookkeeping with tax preparation, or business formation with credit-building. We'll build a custom proposal for you." },
  { q: "What payment methods do you accept?", a: "We accept all major credit and debit cards through Stripe and Bookipi. Recurring services are billed monthly through Bookipi." },
  { q: "How does tax-prep payment work? Do I pay upfront?", a: "No. For most tax returns, our prep fee is deducted directly from your federal refund through EPS Financial (our tax-banking partner). You pay $0 out of pocket at filing. The only exception: if you owe taxes (no refund), payment is due when we file." },
  { q: "How long does credit repair take?", a: "Most clients see meaningful movement in their first 60–90 days. All Anew Credit Repair programs require a 6-month minimum commitment." },
  { q: "Is my information confidential?", a: "Yes. All client data is protected under strict confidentiality, encrypted in transit and at rest, and shared only with team members directly working on your file." },
];

export const TESTIMONIALS = [
  { name: "Marcia D.", role: "Nonprofit Founder", quote: "ConnectHer rebuilt our bookkeeping from the ground up. For the first time in five years, our board reviews real numbers — not guesses." },
  { name: "Jasmine T.", role: "Boutique Owner", quote: "From LLC formation to my first tax return, the team made every step feel doable. I finally feel like I'm running a real business." },
  { name: "Anthony R.", role: "Credit Repair Client", quote: "My score moved 92 points in four months. More importantly, I understand my credit now in a way I never did before." },
];
